import { styled } from '@mui/material';
import { Divider, Icon, Stack, Text, TextInput } from 'shell/components';

const CustomDivider = styled(Divider)(({ theme }) => {
    return {
        width: `calc(100% - ${theme.spacing(2.5)})`,
        margin: theme.spacing(1, 1.25),
    };
});

const TextInputDemo = () => {
    return (
        <Stack divider={<CustomDivider />} spacing={2}>
            <Text variant={'sh1'}>TextInput</Text>
            <Stack spacing={1}>
                <Text variant={'sh2'}>Small Default</Text>
                <TextInput placeholder={'Placeholder'} size={'small'} />
            </Stack>
            <Stack spacing={1}>
                <Text variant={'sh2'}>Medium Default</Text>
                <TextInput placeholder={'Placeholder'} size={'medium'} />
            </Stack>
            <Stack spacing={1}>
                <Text variant={'sh2'}>Large Default</Text>
                <TextInput placeholder={'Placeholder'} size={'large'} />
            </Stack>
            <Stack spacing={1}>
                <Text variant={'sh2'}>Error</Text>
                <TextInput error placeholder={'Placeholder'} />
            </Stack>
            <Stack spacing={1}>
                <Text variant={'sh2'}>Disabled</Text>
                <TextInput disabled placeholder={'Placeholder'} />
            </Stack>
            <Stack spacing={1}>
                <Text variant={'sh2'}>Start Icon</Text>
                <TextInput placeholder={'Placeholder'} startIcon={<Icon kind={'locationEmpty'} />} />
            </Stack>
            <Stack spacing={1}>
                <Text variant={'sh2'}>End Icon</Text>
                <TextInput endIcon={<Icon kind={'search'} />} placeholder={'Placeholder'} />
            </Stack>
            <Stack spacing={1}>
                <Text variant={'sh2'}>Label</Text>
                <TextInput id={'textinput-demo-1'} label={'Form label'} placeholder={'Placeholder'} />
            </Stack>
            <Stack spacing={1}>
                <Text variant={'sh2'}>Required with Label</Text>
                <TextInput id={'textinput-demo-2'} label={'Form label'} placeholder={'Placeholder'} required />
            </Stack>
            <Stack spacing={1}>
                <Text variant={'sh2'}>Helper Text</Text>
                <TextInput
                    id={'textinput-demo-3'}
                    helperText={'Assistive Text'}
                    label={'Form label'}
                    placeholder={'Placeholder'}
                />
            </Stack>
            <Stack spacing={1}>
                <Text variant={'sh2'}>Required with Helper Text</Text>
                <TextInput
                    id={'textinput-demo-4'}
                    helperText={'Assistive Text'}
                    label={'Form label'}
                    placeholder={'Placeholder'}
                    required
                />
            </Stack>
            <Stack spacing={1}>
                <Text variant={'sh2'}>Error with Label</Text>
                <TextInput id={'textinput-demo-5'} error label={'Form label'} placeholder={'Placeholder'} />
            </Stack>
            <Stack spacing={1}>
                <Text variant={'sh2'}>Required with Error and Label</Text>
                <TextInput id={'textinput-demo-6'} error label={'Form label'} placeholder={'Placeholder'} required />
            </Stack>
            <Stack spacing={1}>
                <Text variant={'sh2'}>Error with Helper Text</Text>
                <TextInput
                    id={'textinput-demo-7'}
                    error
                    helperText={'Error Message'}
                    label={'Form label'}
                    placeholder={'Placeholder'}
                />
            </Stack>
            <Stack spacing={1}>
                <Text variant={'sh2'}>Required with Error and Helper Text</Text>
                <TextInput
                    id={'textinput-demo-8'}
                    error
                    helperText={'Error Message'}
                    label={'Form label'}
                    placeholder={'Placeholder'}
                    required
                />
            </Stack>
            <Stack spacing={1}>
                <Text variant={'sh2'}>Disabled</Text>
                <TextInput id={'textinput-demo-9'} disabled label={'Form label'} placeholder={'Placeholder'} />
            </Stack>
            <Stack spacing={1}>
                <Text variant={'sh2'}>Required with Disabled</Text>
                <TextInput
                    id={'textinput-demo-10'}
                    disabled
                    label={'Form label'}
                    placeholder={'Placeholder'}
                    required
                />
            </Stack>
            <Stack spacing={1}>
                <Text variant={'sh2'}>Disabled with Helper Text</Text>
                <TextInput
                    id={'textinput-demo-11'}
                    disabled
                    helperText={'Assistive Text'}
                    label={'Form label'}
                    placeholder={'Placeholder'}
                />
            </Stack>
            <Stack spacing={1}>
                <Text variant={'sh2'}>Required with Disabled and Helper Text</Text>
                <TextInput
                    id={'textinput-demo-12'}
                    disabled
                    helperText={'Assistive Text'}
                    label={'Form label'}
                    placeholder={'Placeholder'}
                    required
                />
            </Stack>
            <Stack spacing={1}>
                <Text variant={'sh2'}>End Icon</Text>
                <TextInput
                    id={'textinput-demo-13'}
                    endIcon={<Icon kind={'search'} />}
                    label={'Form label'}
                    placeholder={'Placeholder'}
                />
            </Stack>
            <Stack spacing={1}>
                <Text variant={'sh2'}>Start Icon</Text>
                <TextInput
                    id={'textinput-demo-14'}
                    label={'Form label'}
                    placeholder={'Placeholder'}
                    startIcon={<Icon kind={'locationEmpty'} />}
                />
            </Stack>
        </Stack>
    );
};

export default TextInputDemo;
